module.exports = __webpack_public_path__ + "static/img/zcjy-1.dac7566.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/temp/zcjy-1.jpg
// module id = nnXf
// module chunks = 1